<div class="section-container flex-grow-1 bg-gray-300 ml-2 p-5">
    <div class="d-flex align-items-center justify-content-between mb-5">
        <h1 class="montserrat-light text-gray-500 text-capitalize">Role Selection</h1>
    </div>

    <div class="row">
        <div class="col-12 mt-4">
            <h4 class="montserrat-light text-gray-500">Login as</h4>

            <form
                name="form"
                [formGroup]="form"
                id="roleSelection"
                (ngSubmit)="onRoleSelected()"
                style="width: 25%"
            >
                <mat-form-field class="form-group dark-input mt-3">
                    <mat-label>Role</mat-label>
                    <mat-select formControlName="role" panelClass="select-panel-down">
                        <mat-option *ngFor="let role of roles" [value]="role">
                            {{ role }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
                <app-error-input [form]="form" [controlName]="'role'"></app-error-input>

                <button class="btn btn-lg btn-gray-500 mt-3" form="roleSelection" type="submit">
                    Proceed
                </button>
            </form>
        </div>
    </div>
</div>
